import { render } from "./PhotoSelectorFromWebcamTab.vue?vue&type=template&id=43c75301"
import script from "./PhotoSelectorFromWebcamTab.vue?vue&type=script&lang=js"
export * from "./PhotoSelectorFromWebcamTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__